<template>
  <div class="d-grid gap-4">
    <div class="card border rounded-lg p-4 shadow-sm bg-white">
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-4">
        <div>
          <h5 class="text-x fw-bold mb-1">{{ translate_label("Columns") }}</h5>
          <p class="text-muted text-xxs mb-0">
            {{ translate_label("Choose the fields that should appear in the report. Keep only the columns that help the reader act quickly.") }}
          </p>
        </div>
        <span class="text-uppercase text-muted text-xxs">
          {{ selected_field_ids.length }} {{ translate_label("selected") }}
        </span>
      </div>

      <div class="row g-3">
        <div v-for="field in available_report_fields" :key="field.id" class="col-12 col-md-6 col-xl-4">
          <label
            class="card border rounded-lg p-3 shadow-sm h-100"
            :class="{ 'border-primary': selected_field_ids.includes(field.id) }"
          >
            <div class="d-flex align-items-center gap-2">
              <input
                :checked="selected_field_ids.includes(field.id)"
                class="form-check-input shadow-sm"
                type="checkbox"
                @change="$emit('toggle-field', field.id)"
              />
              <span class="fw-semibold text-dark text-xxs">{{ field.display_name }}</span>
            </div>
          </label>
        </div>
      </div>

      <div v-if="!has_available_report_fields" class="card border rounded-lg p-3 shadow-sm bg-light mt-3">
        <p class="fw-bold text-dark text-xxs mb-1">{{ translate_label("No columns available") }}</p>
        <p class="text-muted text-xxs mb-0">{{ missing_report_fields_message }}</p>
      </div>
    </div>

    <div v-if="preview_columns.length" class="card border rounded-lg p-4 shadow-sm bg-white">
      <div class="mb-3">
        <h5 class="text-x fw-bold mb-1">{{ translate_label("Column labels") }}</h5>
        <p class="text-muted text-xxs mb-0">
          {{ translate_label("Leave these blank for default wording. Only rename labels when the audience needs client-specific language.") }}
        </p>
      </div>

      <div class="row g-3">
        <div
          v-for="field in preview_columns"
          :key="`display-label-${field.id}`"
          class="col-12 col-xl-6"
        >
          <label class="modal-form-label form-label text-xxs">{{ field.display_name }}</label>
          <input
            :value="get_field_display_label(field.id)"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
            :placeholder="field.display_name"
            type="text"
            @input="$emit('update-field-display-label', { field_id: field.id, value: $event.target.value })"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "report_builder_columns_step",
  props: {
    available_report_fields: { type: Array, required: true },
    get_field_display_label: { type: Function, required: true },
    has_available_report_fields: { type: Boolean, required: true },
    missing_report_fields_message: { type: String, required: true },
    preview_columns: { type: Array, required: true },
    selected_field_ids: { type: Array, required: true },
    translate_label: { type: Function, required: true },
  },
  emits: ["toggle-field", "update-field-display-label"],
};
</script>
